import { createColumnHelper } from '@tanstack/react-table';
import { IMergedHeadersReturn } from './index.headers';
import { IAdminxStore } from '../../stores';
import { useStores } from '@monorepo/controlled/src/hooks/use-stores';
import { useRoute } from '@monorepo/tools/src/lib/hooks/tools/use-route';
import { useEffect } from 'react';
import { WebappsCidModel } from '../../models/webapps-cid.model';

const columnHelper = createColumnHelper<WebappsCidModel>();

export const useWebappsCidHeaders = (): IMergedHeadersReturn<WebappsCidModel> => {
	const { settingsStore } = useStores<IAdminxStore>();
	const { currentRouteWithoutSpecialChars } = useRoute();
	const tableStore = settingsStore.pages.get(currentRouteWithoutSpecialChars)?.tableStore;

	useEffect(() => {
		if (tableStore && Object.keys(tableStore.getColumnVisibility()).length === 0) {
			tableStore.setDefaultColumnVisibility({
				cid: true,
				yid: true,
				name: true,
			});
			tableStore?.setColumnVisibility(tableStore.getDefaultColumnVisibility());
		}
	}, [tableStore]);

	return {
		columns: [
			columnHelper.display({
				id: 'cid',
				header: 'CID',
				cell: ({ row }) => row.original.getCid(),
			}),
			columnHelper.display({
				id: 'yid',
				header: 'Product ID',
				cell: ({ row }) => row.original.getYid() ?? '',
			}),
			columnHelper.display({
				id: 'name',
				header: 'Product Name',
				cell: ({ row }) => row.original.getName() ?? '',
			}),
		],
	};
};
